import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../../Structure/components/Head/Head';
import Footer from '../../../Structure/components/Footer/Footer';
import Filter from '../../../AnimalList/components/AnimalFilter/AnimalFilter';
import ListContainer from '../../../AnimalList/components/AnimalListContainer';
import ProtectoraDetail from './OldProtectoraDetail';
import {
    getAnimalsProtectora,
    getAnimalsProtectoraAvanzado,
    loadInfoProtectoraDetail,
    loadInfoProtectoraDetailImagenYVideo,
    remove,
    removing
} from '../../../AnimalList/actions/actionsAnimalList';
import {resetFilters} from '../../../AnimalList/actions/actionsFilterAnimals';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../../Shared/components/Alerts/AlertsConteiner';
import WaitBlock from "../../../Shared/components/Alerts/WaitBlock";
import {init, sendEmail} from "../../../Shared/actions/actionsContactByEmail";
import {changeStepWaitBlock, showWaitBlock} from "../../../Structure/actions/actionsStructure";
import {checkIsLogin} from "../../../AdminProtectora/actions/actionsAdmin";
import {browserHistory} from "react-router";
import {
    PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID,
    PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN,
    PATH_PROTECTORA_ID
} from "../../../../App/RouterAdopta";
import {LazyLoadImage} from "react-lazy-load-image-component";

class OldProtectoraDetailPage extends Component {
    
    constructor(props) {
        super(props);
        
        this.props.isLogin();
        
        
        var width = window.innerWidth;
        if (width < 992) {
            this.state = {
                elementsPerPage: 12,
                elementsPerRow: 2
            }
        } else {
            this.state = {
                elementsPerPage: 12,
                elementsPerRow: 3
            }
        }
        
        
        this.loadData = this.loadData.bind(this);
        this.EventWaitBlock = this.EventWaitBlock.bind(this);
    }
    
    showLoader() {
        if ($('#especie-filtro input:checked').attr('value') === "Perro") {
            $('#loaderImage img').attr("src", process.env.CDN_URL + "/images/adoptaunanimal/loader/dog.gif");
            // $('#loaderImage img').attr("src", getImageEncode("dog-loader"));
        } else {
            $('#loaderImage img').attr("src", process.env.CDN_URL + "/images/adoptaunanimal/loader/cat.gif");
            // $('#loaderImage img').attr("src", getImageEncode("cat-loader"));
        }
        
        $('#div-space-buttom').show();
        $('#animals-list-container').css('visibility', 'hidden');
        //$('#animals-list-container').hide();
        
        // var inputs = $(".progress-protectora-detail").find($("label"));
        // for (let i = 0; i < inputs.length; i++) {
        //     let index = i + 1;
        //     let time = ((inputs.length) - i) * 100;
        // $(".progress-protectora-detail label:nth-child("+ index+")").css( "-webkit-animation", "anim 1s "+time+"ms infinite ease-in-out" );
        // $(".progress-protectora-detail label:nth-child("+index+")").css( "-animation", "anim 1s "+time+"ms infinite ease-in-out" );
        // }
        
        // $('#loaderImage').removeClass('fadeOut').addClass('animated-300ms fadeIn');
        $('#loaderImage').show();
    }
    
    loadData(num) {
        // const protectoraId = this.props.reducerAccess.isLogin
        //     ? this.props.reducerAccess.id :
        //     this.props.params.id
        //         ? this.props.params.id
        //         : this.props.animalDetailProtectora.infoProtectoraDetail._id;
        
        const protectoraIdParam = this.props.params.id;
        
        if (protectoraIdParam !== undefined) {
            var width = window.innerWidth;
            var info = {};
            if (width < 992) {
                info = {
                    pag: num,
                    numPerRow: 2,
                    numPerPage: 12,
                    varsData: {id_protectora: protectoraIdParam}
                };
            } else {
                info = {
                    pag: num,
                    numPerRow: 3,
                    numPerPage: 12,
                    varsData: {id_protectora: protectoraIdParam}
                };
            }
            // if (this.props.avanzado) {
                this.props.getAnimalsProtectoraAvanzado(info);
            // } else {
            //     this.props.getAnimalsProtectora(info);
            // }
        }
    }
    
    EventWaitBlock(event) {
        if (event === "go") {
            if (this.props.isRemoving) {
                this.props.remove(this.props.access, this.props.animalDetailProtectora.id)
            } else {
                this.props.sendEmail();
            }
        } else {
            if (this.props.waitBlock.stepWaitBlock === 200 || this.props.waitBlock.stepWaitBlock === 201) {
                if (this.props.isRemoving) {
                    this.props.removing(false, "animalsProtectora");
                    
                    this.loadData(this.props.pag)
                    
                    Alert.success('Eliminado correctamente. Tarda un minuto en verse reflejado en el buscador', {
                        position: 'top-right',
                        effect: 'slide',
                        timeout: 6000,
                        customFields: {
                            messageItem: 2,
                            showIconClosed: true,
                            icon: "las la-2x la-thumbs-up"
                        }
                    });
                    
                } else {
                    Alert.success('Enviado correctamente', {
                        position: 'top-right',
                        effect: 'slide',
                        timeout: 6000,
                        customFields: {
                            messageItem: 2,
                            showIconClosed: true,
                            icon: "las la-2x la-thumbs-up"
                        }
                    });
                    this.props.init("animalsProtectora");
                }
            } else {
                Alert.error('Error: ' + this.props.waitBlock.errorWaitBlock, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle"
                    }
                });
            }
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
        }
    }
    
    render() {
        // console.log("OldProtectoraDetailPage::render()");
        let activeCards = {
            animal: true,
            imagenyvideo: true,
            protectora: false,
            metricasAnimal: false
        };
        // const protectoraId = (this.props.reducerAccess.isLogin)
        //     ? this.props.reducerAccess.id : (this.props.params.id) ? this.props.params.id : this.props.animalDetailProtectora.infoProtectoraDetail._id;
        const protectoraId = this.props.params.id
        let showCardProtectoraDetail = false;
        if (this.props.route.path.startsWith(PATH_PROTECTORA_ID)) {
            showCardProtectoraDetail = true;
        }
        
        const nombreProtectora = (this.props.animalDetailProtectora && this.props.animalDetailProtectora.infoProtectoraDetail) ? this.props.animalDetailProtectora.infoProtectoraDetail.nombre : undefined;
        const isAdminAnimals = (this.props.access && this.props.access.id && this.props.access.id === protectoraId && this.props.route && this.props.route.path && this.props.route.path.startsWith(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID))
        const espeiceSeleccionada = (this.props.filter && this.props.filter.especieSeleccionada && this.props.filter.especieSeleccionada !== "ambos") ? this.props.filter.especieSeleccionada.toLowerCase() + "s" : "animales"
        
        if (isAdminAnimals) {
            activeCards.metricasAnimal = true
        } else {
            activeCards.metricasAnimal = false
        }
        //console.log("OldProtectoraDetailPage::render()");
        // console.log("this.props.elementsPerRow="+this.props.elementsPerRow+"");
        // console.log("this.props.elementsPerPage="+this.props.elementsPerPage+"");
        //console.log("this.state.elementsPerRow=" + this.state.elementsPerRow + "");
        //console.log("this.state.elementsPerPage=" + this.state.elementsPerPage + "");
        
        return (
            <div>
                <Head
                    previousPath={"protectoraDetail"}
                />
                {this.props.waitBlock.showWaitBlock &&
                    <WaitBlock
                        message={"Espere por favor..."}
                        methodChange={this.EventWaitBlock}
                    />
                }
                <div id="animals-list" className="container main-content">
                    
                    {(showCardProtectoraDetail) ? (
                        <div>
                            <ProtectoraDetail
                                idProtectora={protectoraId}
                                animalsControl={"animalsProtectora"}
                                animalsControlDetail={"animalDetailProtectora"}
                                isAdminAnimals={isAdminAnimals}
                            />
                        </div>
                    ) : (
                        <div/>
                    )}
                    <div className="protectora-detail__heading">
                        {this.props.access.isLogin
                        && this.props.access.id === this.props.params.id
                        && !showCardProtectoraDetail
                            ? (
                                <h2>Estos son los {espeiceSeleccionada} en que tienes registrados</h2>
                            ) : (
                                <h2>Estos son los {espeiceSeleccionada} en adopción de {nombreProtectora}</h2>
                            )
                        }
                    </div>
                    <div className="row">
                        <div id="" className="col-lg-3">
                            <Filter
                                loader={this.showLoader.bind(this)}
                                loadData={this.loadData}
                                isAdminAnimals={isAdminAnimals}
                                filterControl={"filtersControlProtectora"}
                                varsData={
                                    {id_protectora: protectoraId}
                                }
                            />
                        </div>
                        <div id="loaderImage">
                            <LazyLoadImage threshold={150} src=""/>
                            <div className="loaderImageText">B U S C A N D O . . .</div>
                        </div>
                        <div id="animals-list-container" className="col-lg-9">
                            <ListContainer
                                list={this.props.animals}
                                methodLoad={this.loadData}
                                totalRecord={this.props.totalRecord}
                                pag={this.props.pag}
                                elementsPerRow={this.state.elementsPerRow}
                                elementsPerPage={this.state.elementsPerPage}
                                animalsControl={"animalsProtectora"}
                                animalsControlDetail={"animalDetailProtectora"}
                                activeCards={
                                    activeCards
                                }
                                isAdminAnimals={isAdminAnimals}
                                // animalIdParam={this.props.params.id}
                            />
                        </div>
                    </div>
                    <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
                </div>
                <Footer
                    percent={100}
                    configFooter={
                        {"moreInfo": false}
                    }
                />
            </div>
        );
    }
    
    componentWillMount() {
        // if (!this.props.reducerAccess.isLogin) {
        //     browserHistory.push('/login');
        // }else{
        //5ed931d79ddab81ad41852a6
        
        
        if (this.props && this.props.route && this.props.route.path && this.props.route.path.startsWith('/buscador/admin/adminAnimal')) {
            
            
            if (!this.props.access.isLogin) {
                return browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN)
            } else if (this.props.access.id !== this.props.params.id) {
                this.props.params.id = this.props.access.id
                return browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID + this.props.access.id)
            } else {
                this.loadData(0);
            }
        } else {
            
            
            this.props.resetFilters("filtersControlProtectora");
            this.props.loadInfoProtectoraDetail(this.props.params.id, this.props.animalsControl, "completa");
            // this.props.loadInfoProtectoraDetailImagenYVideo(this.props.idProtectora, "pesada");
            this.loadData(0);
            
            //Initial scroll
            // let element = $("body");
            // if (element.length !== 0) {
            //     console.log("Haciendo scrollTop: 0");
            //     $('body,html').stop(true,true).animate({
            //         scrollTop: element.offset().top
            //     },100);
            //
            //     // element.scrollTop(0);
            //     // $(window)[0].scrollTo(0,0);
            // }
            
            
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
        }
    }
    
    componentDidMount() {
        // let element = $("body");
        
        //$('#loaderImageIni').fadeOut();
        //$('#animals-list-container').hide();
        // $('#animals-filter').addClass('animated-0s fadeIn');
        
        // let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        
        if (!this.props.showHead) {
            // $('.header-topbar').addClass('animated-400ms fadeInDown').one(animationEnd, () => {
            //     $('.header-topbar').removeClass('animated-400ms fadeInDown');
            // });
            //$('.header-topbar').css("visibility", "visible");
        } else {
            // $('.header-topbar').removeClass('animated-400ms fadeInDown');
            //$('.header-topbar').css("visibility", "visible");
        }
        
        if (!this.props.showFooter) {
            // $('.footer-default').addClass('animated-400ms fadeIn');
            $('.footer-default').show();
        } else {
            // $('.footer-default').removeClass('animated-400ms fadeIn');
            $('.footer-default').show();
        }
        
        this.showLoader();
        
    }
    
    componentDidUpdate() {
        if (this.props.waitBlock.showWaitBlock) {
            $('#modal-container').removeClass('out').addClass("one");
            $('body').addClass('modal-active');
        } else {
            $('body').removeClass('modal-active');
        }
    }
    
    
}

function mapStateToProps(state, ownProps) {
    //console.log("OldProtectoraDetailPage::mapStateToProps()");
    // console.log("animalsProtectora.elementsPerRow = '" + state.animalsProtectora.elementsPerRow + "'");
    // console.log("animalsProtectora.elementsPerPage = '" + state.animalsProtectora.elementsPerPage + "'");
    return {
        animals: state.animalsProtectora.list,
        totalRecord: state.animalsProtectora.totalRecord,
        pag: state.animalsProtectora.pag,
        // elementsPerRow: state.animalsProtectora.elementsPerRow,
        // elementsPerPage: state.animalsProtectora.elementsPerPage,
        avanzado: state.filtersControlProtectora.avanzado,
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        animalDetailProtectora: state.animalDetailProtectora,
        isRemoving: state.animalsProtectora.isRemoving,
        waitBlock: state.structureControl,
        access: state.access,
        filter: state["filtersControlProtectora"]
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    getAnimalsProtectora,
    getAnimalsProtectoraAvanzado,
    resetFilters,
    sendEmail: sendEmail,
    changeWaitBlock: showWaitBlock,
    changeStepWaitBlock,
    init,
    removing,
    remove,
    isLogin: checkIsLogin,
    loadInfoProtectoraDetail,
    loadInfoProtectoraDetailImagenYVideo
})(OldProtectoraDetailPage)
